function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14H20.5L16.7561 19H10.7439L8 14Z",
  fill: "#7249E8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07871 2H19.9213C23.0335 2 24.9535 5.3978 23.3478 8.06378L16.7609 19V22.7391C16.7609 24.5401 15.3009 26 13.5 26C11.6991 26 10.2391 24.5401 10.2391 22.7391V19L3.65223 8.06378C2.0465 5.3978 3.96651 2 7.07871 2Z",
  stroke: "#0C0030",
  strokeWidth: 3
});

var SvgFunnelThirdStepColored = function SvgFunnelThirdStepColored(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFunnelThirdStepColored, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/funnel-third-step-colored.6d1e53ec.svg";
export { ForwardRef as ReactComponent };